import makeRequest from '@jg/http-client';
import { ThunkDispatch } from 'redux-thunk';
import { Action } from 'redux';
import { Auth } from '@jg/auth';
import { httpActions } from '..';
import { REQUEST, ERROR_MESSAGES } from '../../consts';
import config from '../../config';
import { IAppState } from '../../types/state.d';
import { getShortName, getTeamGuid } from '../../selectors/apiSelectors';
import { generateAuthHeaders, redirectByResponseStatus } from '../../utils';

const updateShortName = () => async (
  dispatch: ThunkDispatch<IAppState, void, Action>,
  getState: () => IAppState,
  auth: Auth,
) => {
  const resourceName = REQUEST.UPDATE_SHORT_NAME;
  try {
    await auth.refreshAccessTokenIfExpired();
    dispatch(httpActions.httpRequestMade(resourceName));
    const teamGuid = getTeamGuid(getState());
    const shortName = getShortName(getState());

    const response = await makeRequest(
      `${config.pagesAPI}v1/teams/${teamGuid}/details/shortName`,
      {
        method: 'PUT',
        body: JSON.stringify({
          shortName,
        }),
        extraHeaders: generateAuthHeaders(auth),
      },
    );
    if (response && !response.ok) {
      redirectByResponseStatus(response.status);
      throw new Error(ERROR_MESSAGES.UPDATE_SHORT_NAME);
    }
    dispatch(httpActions.httpRequestSuccess(resourceName));
  } catch (error) {
    dispatch(httpActions.httpRequestError(resourceName, error));
    redirectByResponseStatus(error.status);
    throw error;
  }
};

export default updateShortName;
